/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    userFacingMessage?: string;
}

export function ErrorResponseFromJSON(json: any): ErrorResponse {
    return {
        'userFacingMessage': !exists(json, 'userFacingMessage') ? undefined : json['userFacingMessage'],
    };
}

export function ErrorResponseToJSON(value?: ErrorResponse): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'userFacingMessage': value.userFacingMessage,
    };
}


